<template>
  <div class="service-request-page-step3">
    <div
      v-if="form && typeof form === 'object' && !form.unknown_number"
      key="fields-state"
      class="service-request-page-step3__fields"
    >
      <BaseInput
        v-model="form.state_number"
        :label="getMain && getMain.form && getMain.form.state_number && getMain.form.state_number.label"
        :required="true"
        :errorMsg="errorMsgs && errorMsgs.state_number"
        :customMessageText="isMd() ? getMain.stateNumberErrorTextMd : getMain.stateNumberErrorText"
        class="service-request-page__form-input service-request-page__form-input-state"
        :validatePatternState="true"
        :onlyUppercase="true"
        @update:errorCustom="stateNumberError = $event"
        @input="onStateNumberInput"
      />

      <BaseInput
        key="vin-with-state"
        v-model="form.vin_number"
        :disabled="!isMd()"
        :label="getMain && getMain.form && getMain.form.vin_number && getMain.form.vin_number.label"
        :required="getMain && getMain.form && getMain.form.vin_number && getMain.form.vin_number.required"
        :errorMsg="errorMsgs && errorMsgs.vin_number"
        class="service-request-page__form-input"
        :validatePatternVin="true"
        :onlyUppercase="true"
        @input="onVinUpdate"
      />
    </div>

    <div
      v-if="form && typeof form === 'object' && form.unknown_number"
      key="fields-unknown"
      class="service-request-page-step3__fields-4"
    >
      <BaseInput
        key="vin-unknown"
        v-model="form.vin_number"
        :label="getMain && getMain.form && getMain.form.vin_number && getMain.form.vin_number.label"
        :required="getMain && getMain.form && getMain.form.vin_number && getMain.form.vin_number.required"
        :errorMsg="errorMsgs && errorMsgs.vin_number"
        class="service-request-page__form-input"
        :onlyUppercase="true"
        max="17"
        :validatePatternVin="true"
        @input="onVinUpdate"
      />

      <BaseSelectNew
        v-model="form.model"
        :items="models"
        :placeholder="getMain && getMain.form && getMain.form.model && getMain.form.model.placeholder"
        :label="getMain && getMain.form && getMain.form.model && getMain.form.model.label"
        :required="getMain && getMain.form && getMain.form.model && getMain.form.model.required"
        :errorMsg="errorMsgs && errorMsgs.model"
        class="service-request-page__form-input-date"
      />

      <BaseSelectNew
        v-model="form.year"
        :items="generations"
        :placeholder="getMain && getMain.form && getMain.form.year && getMain.form.year.placeholder"
        :label="getMain && getMain.form && getMain.form.year && getMain.form.year.label"
        :required="getMain && getMain.form && getMain.form.year && getMain.form.year.required"
        :errorMsg="errorMsgs && errorMsgs.year"
        class="service-request-page__form-input-date"
      />

      <BaseSelectNew
        v-model="form.engine"
        :items="engines"
        :label="getMain && getMain.form && getMain.form.engine && getMain.form.engine.label"
        :placeholder="getMain && getMain.form && getMain.form.engine && getMain.form.engine.placeholder"
        :required="getMain && getMain.form && getMain.form.engine && getMain.form.engine.required"
        :errorMsg="errorMsgs && errorMsgs.engine"
        :autoSelect="Boolean(engines) && Boolean(engines.length) && Boolean(engines.length <= 1)"
        class="service-request-page__form-input-engine"
      />
    </div>

    <BaseCheckbox
      v-if="form && typeof form === 'object'"
      v-model="form.unknown_number"
      class="consultation-step3__form-input"
      @input="checkboxChange"
    >
      {{ getMain.form && getMain.form.unknown_number && getMain.form.unknown_number.label }}
    </BaseCheckbox>

    <div class="preloader-loading" :class="{ show: loading }">
      {{ getMain.loadingInformationText }}
    </div>

    <BaseButton
      class="service-request-page__button"
      type="primary"
      :disabled="!isButtonEnabled"
      @click="submitForm"
    >
      {{ getMain.continueButtonText }}
    </BaseButton>

    <Modal v-model="isModalOpen" @close="isModalOpen = false">
      <div class="modal-content">
        <h4>{{ getMain.notFoundInfoText }}</h4>
        <BaseButton
          class="modal-submit-button"
          type="primary"
          @click="manualEdit"
        >
          {{ getMain.handleInputLabel }}
        </BaseButton>
      </div>
    </Modal>
  </div>
</template>

<script>
  import { mapGetters, mapActions, mapState } from 'vuex'
  import IconArrow from '@/assets/img/icons/arrow-long-right.svg?inline'
  import debounce from 'lodash/debounce'
  import Modal from '@/components/Modal.vue'
  import { isMd } from '@/config'

  const VIN_REGEX = /^[A-HJ-NPR-Z0-9]{17}$/i

  export default {
    name: 'Step3',

    components: { Modal, IconArrow },

    props: {
      form: {
        type: [Object, String],
        required: true
      },
      errorMsgs: {
        type: Object,
        default: function () {
          return {}
        }
      },
      submitForm: {
        type: Function,
        required: true
      },
      checkboxState: Boolean,
      onCheckboxUnknownChange: Function,
      getVINCodeAction: Function
    },

    data () {
      return {
        models: [],
        generations: [],
        engines: [],
        stateNumberError: '',
        dataVin: {},
        vinCorrect: false,
        stateCorrect: false,
        loading: false,
        loadingTimeout: null,
        isModalOpen: false,
        fetchVinCancelled: false
      }
    },
    computed: {
    ...mapGetters(['getMain', 'isShow', 'getPhoneType']),
    ...mapState(['currentLang']),

    isButtonEnabled () {
      if (!this.form || typeof this.form !== 'object') return false

      if (!this.form.unknown_number) {
        if (isMd) {
          return !this.stateNumberError && this.stateCorrect && (this.form.vin_number.length === 0 || this.vinCorrect)
        } else {
          return !this.stateNumberError && this.stateCorrect && this.vinCorrect
        }
      }

      if (this.form.unknown_number) {
        const vinRequired = this.getMain && this.getMain.form && this.getMain.form.vin_number && this.getMain.form.vin_number.required
        return Boolean(this.form.model && this.form.year && this.form.engine) &&
          (vinRequired
            ? this.form.vin_number.length && this.vinCorrect
            : !this.form.vin_number.length || this.vinCorrect)
      }

      return this.stateCorrect
    }
    },

    watch: {
      'form.model': {
        async handler (modelValue) {
          if (!this.form.unknown_number && !isMd) return

          this.generations = []
          this.engines = []
          this.form.year = ''
          this.form.engine = ''

          const model = this.models.find(el => el.value === modelValue)
          if (!model || !model.id) return

          try {
            const { data } = await window.axios.get(
              `${process.env.VUE_APP_TO_API_URL}/forms-api/default/generations`,
              { params: { model_id: model.id } }
            )

            if (data && data.generations) {
              this.generations = data.generations.map(year => ({
                value: `${year}`,
                text: `${year}`,
                ids: data.ids
              }))

              if (this.generations.length === 1) {
                this.form.year = this.generations[0].value
              }
            }

            if (Object.keys(this.dataVin).length) {
              const findGeneration = this.generations.find(el => el.text === String(this.getYearFromDate(new Date(this.dataVin.productionDate))))
              if (findGeneration) {
                this.form.year = findGeneration.value
                this.form.engine = this.dataVin.fuelType
              }
            }
          } catch (e) {
            console.error(e)
          }
        }
      },
      'form.year': {
        async handler (generationValue) {
          const year = this.generations.find(el => el.value === generationValue)

          if (!year || !year.ids) return

          try {
            const { data } = await window.axios.get(
              `${process.env.VUE_APP_TO_API_URL}/forms-api/default/engines`,
              { params: { generation_ids: year.ids } }
            )

            if (data && data.engines) {
              const newEngines = data.engines.map(engine => ({
                value: engine.id,
                text: engine.label
              }))

              const oldValues = this.engines.map(e => e.value).sort()
              const newValues = newEngines.map(e => e.value).sort()

              const enginesChanged = oldValues.length !== newValues.length ||
                oldValues.some((v, i) => v !== newValues[i])

              if (!enginesChanged) return

              this.engines = newEngines
              if (Object.keys(this.dataVin).length && this.dataVin.fuelType) {
                return
              }
              if (this.engines.length === 1) {
                this.form.engine = this.engines[0].value
              }
            }
          } catch (e) {
            console.error(e)
          }
        }
      }
    },

    mounted () {
      this.getModels()
    },

    beforeDestroy () {
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout)
      }
    },

    methods: {
      isMd () {
        return isMd
      },
    ...mapActions(['submitServiceRequest']),

      onStateNumberInput: debounce(function (value) {
        if (isMd) {
          this.stateCorrect = true
          return
        }
        if (!value) {
          this.stateCorrect = false
          this.form.vin_number = ''
        }
        if (this.stateNumberError) return

        this.fetchVin(value)
      }, 300),

      getYearFromDate (date) {
        return date.getFullYear()
      },

      getFuelByVin: async function (vin) {
        const { data } = await window.axios.post(
          `${process.env.VUE_APP_TO_API_URL}/fuel-by-vin`,
          { vin }
        )
        return data
      },
      onVinUpdate: function (val) {
        if (val === '') {
          if (isMd) {
            this.vinCorrect = true
          }
          this.dataVin = {}
          this.form.model = ''
          this.form.year = ''
          this.form.engine = ''
        } else if (VIN_REGEX.test(val)) {
          this.form.model = ''
          this.form.year = ''
          this.form.engine = ''
          this.dataVin = {}
          this.fetchVinUnknown(val)
        } else {
          this.dataVin = {}
          this.vinCorrect = false
        }
      },

      async fetchVin (stateNumber) {
        this.fetchVinCancelled = false
        this.loadingTimeout = setTimeout(() => {
          this.loading = true
        }, 1000)

        try {
          const response = await window.axios.get('/service-check-number/' + stateNumber)
          if (this.fetchVinCancelled) return

          if (response && response.data) {
            const { vin, model, makeYear, fuel } = response.data

            if (!vin) {
              this.$emit('update:vin_number', '')
              this.isModalOpen = true
              return
            }

            if (vin) {
              const data = await this.getVINCodeAction(vin)
              if (this.fetchVinCancelled) return

              if (data.status === 'INVALID') {
                this.$emit('update:vin_number', '')
                this.isModalOpen = true
                return
              }

              if (this.fetchVinCancelled) return

              this.$emit('update:vin_number', vin || '')

              if (data && data.modelName && data.modelName !== '-') {
                this.form.model = data.modelName
              } else if (model) {
                this.form.model = model
              } else {
                this.form.model = '-'
              }
            } else {
              this.$emit('update:vin_number', '')
            }

            if (this.fetchVinCancelled) return
            this.form.year = makeYear ? `${makeYear}` : '-'

            const fuelResponse = await this.getFuelByVin(vin)
            if (this.fetchVinCancelled) return

            const fuelType = fuelResponse.fuelType ? fuelResponse.fuelType : fuel
            this.form.engine = fuelType ? `${fuelType}` : '-'
            this.stateCorrect = true
            this.vinCorrect = true
          }
        } catch (e) {
          console.error('VIN error', e)
          this.$emit('update:vin_number', '')
          this.stateCorrect = false
        } finally {
          clearTimeout(this.loadingTimeout)
          this.loading = false
        }
      },

      async fetchVinUnknown (vincode) {
        this.loadingTimeout = setTimeout(() => {
          this.loading = true
        }, 1000)

        try {
          const data = await this.getVINCodeAction(vincode)

          if (data.modelName && data.modelName !== '-') {
            const model = this.models.find(el => {
              return data.modelName.toLowerCase().startsWith(el.value.toLowerCase())
            })
            if (model) {
              this.dataVin = data

              if (this.form.unknown_number || isMd) {
                const fuelResponse = await this.getFuelByVin(vincode)

                if (fuelResponse && fuelResponse.fuelType) {
                  this.dataVin = { ...this.dataVin, fuelType: fuelResponse.fuelType }
                }
              }
              this.form.model = model.value
            }
            this.vinCorrect = true
            this.loading = false
            this.$emit('update:activeLoading', false)
          } else {
            this.vinCorrect = true
            this.form.model = ''
            this.form.year = ''
            this.form.engine = ''
            this.dataVin = {}
            this.$emit('update:activeLoading', false)
          }
        } catch (e) {
          console.error('VIN error', e)
          this.vinCorrect = false
          this.dataVin = {}
        } finally {
          clearTimeout(this.loadingTimeout)
          this.loading = false
        }
      },

      async getModels () {
        if (!this.form || typeof this.form !== 'object') return

        this.form.model = ''
        this.form.year = ''
        this.form.engine = ''

        try {
          const response = await window.axios.get(
            `${process.env.VUE_APP_TO_API_URL}/forms-api/default/models`
          )

          if (response && response.data && response.data.models) {
            this.models = response.data.models.map(el => ({
              value: el.label,
              text: el.label,
              id: el.id
            }))
          } else {
            this.models = []
          }
        } catch (e) {
          console.error(e)
          this.models = []
        }
      },

      manualEdit () {
        this.isModalOpen = false
        this.form.model = ''
        this.form.year = ''
        this.form.engine = ''
        this.form.unknown_number = true
        this.vinCorrect = false
        this.stateCorrect = false
      },
      checkboxChange () {
        if (this.onStateNumberInput && this.onStateNumberInput.cancel) {
          this.onStateNumberInput.cancel()
        }
        this.fetchVinCancelled = true
        this.$emit('update:vin_number', '')
        this.form.vin_number = ''
        this.form.state_number = ''
        this.dataVin = {}
        this.form.model = ''
        this.form.year = ''
        this.form.engine = ''
        this.stateNumberError = ''
        this.vinCorrect = false
        this.loading = false
        this.stateCorrect = false
        this.onCheckboxUnknownChange()
      }
    }
  }
</script>

<style lang="scss">

.service-request-page-step3 {
  .select {
    @include tablet {
      margin-bottom: 16px;
    }

    .select__dropdown {
      top: 58px;
    }
  }

  .consultation-step3__form-input {
    margin-top: 5px;

    @include tablet {
      margin-top: 0;
    }

    .checkbox__text {
      font-size: 13px;
      margin-left: 15px;
    }
  }

  .service-request-page__form-input-state input {
    text-transform: uppercase;
  }

  .modal-submit-button {
    display: flex;
    font-family: 'Toyota Type', sans-serif;
    font-weight: 700;
    text-transform: uppercase;
    font-size: 14px;
    line-height: 20px;
    padding: 12px 16px;
    letter-spacing: 1px;
    border-radius: 4px;
    margin-top: 32px;
  }

  .checkbox-wrapper {
    width: max-content;
    padding-top: 0;
    padding-bottom: 0;
  }

  .service-request-page__button {
    margin-top: 20px;
  }
}

.service-request-page {
  &__form-input-date {
    margin-bottom: 0;
  }

  &__form-input-phone {
    margin-top: 16px;
  }

  input[type=number]::-webkit-outer-spin-button,
  input[type=number]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }

  .service-request-page-step3__fields {
    display: grid;
    grid-template-columns: 364px 364px 1fr;
    width: 100%;
    gap: 24px;

    .input-wrapper {
      width: 100% !important;
      padding-bottom: 25px;

      @include tablet {
        padding-bottom: 0;
      }
    }

    &-4 {
      display: grid;
      width: 100%;
      gap: 24px;
      grid-template-columns: 1fr 1fr 1fr 1fr;

      @include tablet {
        grid-template-columns: 1fr 1fr;
        column-gap: 16px;
        row-gap: 0;

        .input-wrapper {
          padding-bottom: 16px;
        }

        .select {
          padding-bottom: 16px;

          @include tablet {
            padding-bottom: 0;
          }
        }
      }

      @include mobile {
        grid-template-columns: 1fr;
        gap: 2px;
      }

      .input-wrapper {
        min-width: 0;
      }

      .select {
        min-width: 0;
      }
    }

    @include tablet {
      grid-template-columns: 1fr 1fr;
      gap: 16px;
      margin-bottom: 16px;
    }

    @include mobile {
      grid-template-columns: 1fr;
      gap: 16px;
      margin-bottom: 16px;
    }
  }

  .service-request-page__form-input {
    margin-bottom: 0;
  }

  .preloader-loading {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 0;
    top: 0;
    padding: 12px;
    background: white;
    border-radius: 4px;
    text-align: center;
    transition: 0.5s;
    opacity: 0;
    visibility: hidden;
    font-family: 'NobelWGL-Book', sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.14px;

    &.show {
      opacity: 1;
      visibility: visible;
    }
  }

  .service-request-page__form-input-engine {
    @media (max-width: 767px) {
      margin-bottom: 16px !important;
    }
  }
}
</style>
